import React, { useEffect, useState } from 'react';

const ThankYouPage: React.FC = () => {
  const [userEmail, setUserEmail] = useState('');
  const [companyName, setCompanyName] = useState('');

  useEffect(() => {
    const email = localStorage.getItem('userEmail') || '';
    const company = localStorage.getItem('companyName') || '';
    setUserEmail(email);
    setCompanyName(company);
  }, []);

  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#f8f9fa', padding: '40px 0' }}>
      <div className="container">
        <div style={{ maxWidth: '600px', margin: '0 auto', textAlign: 'center' }}>
          <div className="card">
            <div style={{ marginBottom: '30px' }}>
              <div style={{ 
                fontSize: '64px', 
                color: '#28a745', 
                marginBottom: '20px' 
              }}>
                ✓
              </div>
              <h1 style={{ color: '#2c3e50', marginBottom: '20px' }}>
                Thank You!
              </h1>
              <p style={{ fontSize: '18px', color: '#6c757d', marginBottom: '30px' }}>
                Your subscription has been successfully activated.
              </p>
            </div>

            <div style={{ 
              backgroundColor: '#f8f9fa', 
              padding: '20px', 
              borderRadius: '8px', 
              marginBottom: '30px' 
            }}>
              <h3 style={{ marginBottom: '15px', color: '#2c3e50' }}>Account Details</h3>
              <p><strong>Company:</strong> {companyName}</p>
              <p><strong>Email:</strong> {userEmail}</p>
              <p><strong>Status:</strong> <span style={{ color: '#28a745', fontWeight: 'bold' }}>Active</span></p>
            </div>

            <div style={{ marginBottom: '30px' }}>
              <h3 style={{ marginBottom: '15px', color: '#2c3e50' }}>What's Next?</h3>
              <div style={{ textAlign: 'left' }}>
                <p style={{ marginBottom: '10px' }}>✓ Check your email for account confirmation</p>
                <p style={{ marginBottom: '10px' }}>✓ Set up your team and permissions</p>
                <p style={{ marginBottom: '10px' }}>✓ Import your existing client data</p>
                <p style={{ marginBottom: '10px' }}>✓ Start creating your first work orders</p>
              </div>
            </div>

            <button 
              className="btn btn-primary"
              onClick={() => window.location.href = '/login'}
              style={{ 
                width: '100%', 
                padding: '15px', 
                fontSize: '18px',
                marginBottom: '15px'
              }}
            >
              Access Your CRM Dashboard
            </button>

            <p style={{ fontSize: '14px', color: '#6c757d' }}>
              Need help getting started? Contact our support team at support@hvaccrm.com
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ThankYouPage;